export enum TicketPriorityRouteName {
    Index = 'ticket-priorities.index',
    Create = 'ticket-priorities.create',
    Edit = 'ticket-priorities.edit',
}

export default {
    path: 'ticket-priorities',
    name: TicketPriorityRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Ticket Priorities',
        icon: 'fal fa-ballot-check fa-fw',
        location: 'sidebar',
        permission: 'manage-tickets',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: TicketPriorityRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Ticket Priority',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
        {
            path: ':ticketPriorityUuid/edit',
            name: TicketPriorityRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Ticket Priority',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
    ],
}
